// Task Module
import { collection, doc } from "firebase/firestore";
import { db } from "../../firebase/firebase.js";

export const tasksCollection = collection(db, "tasks");

export const taskDoc = (id) => doc(db, "tasks", id);
